export default {
  en: {
    'bundles.jurisdictions.jurisdictions-list-page.components.jurisdiction-list-item.active-count':
      '{count} registration{count, plural, one {} other {s}}',
    'bundles.jurisdictions.jurisdictions-list-page.components.jurisdiction-list-item.inactive-count':
      '{count} inactive registration{count, plural, one {} other {s}}',
  },
};
